// extracted by mini-css-extract-plugin
export default {"stlogo":"Logo_stlogo__Mdg8S","stlogo__img":"Logo_stlogo__img__xmL18","stlogo__txt":"Logo_stlogo__txt__IvBkq"};